exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icongreen[data-v-632bc766]{color:#4caf50;background-color:transparent}.iconred[data-v-632bc766]{color:red;background-color:transparent}.iconyellow[data-v-632bc766]{color:orange;background-color:transparent}.iconblue[data-v-632bc766]{color:#007fff;background-color:transparent}", ""]);

// exports
